import React from 'react';
import { Popup } from 'react-chat-elements';

const PrivacyPopup = ({ show, src, onClose }) => {
  return (
    <Popup
      show={show}
      header="Informativa Privacy di AIR"
      text={
        <iframe
            className='pdf-iframe'
            src={src}
            style={{ border: 'none' }}
            title="Informativa Privacy"
        />
      }
      headerButtons={[
        {
          type: 'close',
          backgroundColor: 'white',
          color: 'var(--chatbot-primary-color)',
          text: 'X',
          onClick: onClose,
        },
      ]}
    />
  );
};

export default PrivacyPopup;
